<template>
  <div class="mains">
    <div class="campus">
      习题管理
      <span>></span>
      制作习题
      <span>></span>
      大题列表
      <span>></span>
      小题列表
      <span>></span>
      编辑多选题
    </div>
    <div class="student_test">
      <el-card>
        <div class="grid-content">
          <div class="rule">
            <div class="xiaoqu_1">制作习题</div>
            <div class="xiaoqu_2">
            </div>
          </div>
          <p class="tishi">
            <i>
              <img src="@/assets/img/education-manage/campus/shenzhong.png" alt />
            </i> 功能前方标注红色星号的属于必填内容，未标星号的是选填内容可进行自由填写，不同功能的备注事宜写在功能后方
          </p>
          <div class="form_1">
            <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
              <el-form-item label="习题范例" v-show="show">
                <div class="xtfl1">
                  <h3>what is that ?</h3>
                  <div class="example_img">
                    <img src="../../../../assets/img/xitifanli.png" alt="">
                  </div>
                  <div class="example">
                    <span>A: apple</span>
                    <span>B: banana</span>
                    <span>C: pear</span>
                    <span>D: orange</span>
                  </div>
                  <el-button @click="show=false" v-show="show" type="primary">收起</el-button>
                </div>

              </el-form-item>
              <el-form-item label="小题题目" prop="title">
                <el-input type="textarea" v-model="form.title" class="xtfl" rows="5"></el-input>
                <div class="expansion">
                  <el-button @click="show=true" v-show="!show" type="primary">展开</el-button>
                </div>
              </el-form-item>
              <el-form-item label="查看图片">
                <div class="look_picture">
                  <img :src="imageUrl" class="avatar" />
                  <div class="replaceaudio">
                    <el-button v-if="imageUrl" @click="removeimage" type="primary" class="picture" round>删除图片</el-button>
                    <el-upload v-else action="#" :show-file-list="false" :http-request="handleAvatarSuccessImg" :before-upload="beforeAvatarUploadImg">
                      <div class="picture">
                        <el-button type="primary" round>
                          导入图片
                        </el-button>
                      </div>
                    </el-upload>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="小题选项" prop="chooseListAnswer">
                <el-checkbox-group v-model="form.chooseListAnswer" @change="selector()">
                  <div class="options" v-for="(item, index) in chooseList" :key="index">
                    <div class="options_left">
                      <p>{{item.label}}</p>
                      <el-checkbox :label="item.label" class="options_left_radio">设为正确答案</el-checkbox>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" v-model="item.content" rows="9" cols="85">111</el-input>
                      <div class="right_button">
                        <div style="position:absolute; top:80px; left:15px; width:100px; height:100px;" v-if="item.img">
                          <img :src="item.img" alt="" style="width:100%;">
                        </div>
                        <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request=" handleAvatarSuccessImg1">
                          <el-button v-if="!item.img" type="primary" class="mt-1" @click="selector1(item)">
                            + 导入图片
                          </el-button>
                        </el-upload>
                        <el-button v-if="item.img" type="primary" style="width:110px; height:40px; margin:11px 0 0 0;" @click="removeitemimg(item)">
                          删除图片
                        </el-button>
                      </div>
                    </div>
                  </div>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" size="mini" @click="addChooseList">+添加选项</el-button>
                <el-button type="primary" size="mini" @click="removeChooseList">-删减选项</el-button>
              </el-form-item>
              <el-form-item label="答案解析" prop="answerparse">
                <el-input type="textarea" v-model="form.answerparse" class="xtfl" rows="5" placeholder="您可自由输入该习题的答案解析"></el-input>
              </el-form-item>
              <el-form-item label="难易程度" prop="radios">
                <el-radio-group v-model="form.radios">
                  <el-radio :label="1">易</el-radio>
                  <el-radio :label="2">中</el-radio>
                  <el-radio :label="3">难</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="知识点" prop="knowledge">
                <el-input type="textarea" v-model="form.points" class="xtfl" rows="5" placeholder="您可自行输入该题目所涉及到的知识点，可自由选择是否输入"></el-input>
              </el-form-item>
              <el-form-item class="tijiao">
                <el-button type="primary" @click="updatechoice()" v-if="edit" style="width:240px; height:46px; marginLeft:30px;">继续制题</el-button>
                <el-button type="primary" @click="editupdate()" v-else style="width:240px; height:46px; marginLeft:30px;">保存编辑</el-button>
                <el-button style="width:240px; height:46px; marginLeft:30px;" v-show="edit" @click="comeBack=true">保存并返回</el-button>

                <div style="marginLeft:270px;" v-show="comeBack">
                  <el-button style="width:240px; height:46px; marginLeft:30px;" @click="comeBackBig(1)">返回大题列表</el-button>
                  <div>
                    <el-button style="width:240px; height:46px; marginLeft:30px;" @click="comeBacksmall(2)">返回小题列表</el-button>
                  </div>

                </div>
              </el-form-item>
            </el-form>
          </div>

        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
const axios = require('axios');
export default {
  data() {
    return {
      form: {
        title: '',
        answerparse: '',
        points: '',
        radios: '',
        chooseListAnswer: [],
      },
      FormRules: {
        title: [{ required: true, message: '请您填写必填信息', trigger: 'blur' }],
        chooseListAnswer: [{ required: true, message: '请您填写必填信息', trigger: 'blur' }],
        radios: [{ required: true, message: '请您填写必填信息', trigger: 'blur' }],
      },

      chooseaudioid: '',
      radio1: '',
      show: true,
      audiosrc: '',
      imageUrl: '',
      indexs: 4,
      chooseList: [],
      chooseList1: [
        {
          label: 'A',
          radio1: '',
          audio: '',
          img: '',
          id: '',
          content: '',
          right: 1,
        },
        {
          label: 'B',
          radio1: '',
          audio: '',
          img: '',
          id: '',
          content: '',
          right: 1,
        },
        {
          label: 'C',
          radio1: '',
          audio: '',
          img: '',
          id: '',
          content: '',
          right: 1,
        },
        {
          label: 'D',
          radio1: '',
          audio: '',
          img: '',
          id: '',
          content: '',
          right: 1,
        },
        {
          label: 'E',
          radio1: '',
          audio: '',
          img: '',
          id: '',
          content: '',
          right: 1,
        },
        {
          label: 'F',
          radio1: '',
          audio: '',
          img: '',
          id: '',
          content: '',
          right: 1,
        },
      ],
      optionsId:'',
      questionPackId:'',
      edit: true,
      comeBack: false,
      accountForm: {
        photo: {
          icon: require('@/assets/img/xitifanli.png'),
        },
      },
    };
  },
  created() {
    this.verdict();
  },

  methods: {
    verdict() {
      console.log(this.$route.query.questionId);
      if (this.$route.query.questionId === undefined) {
        this.addnumber();
      } else {
        this.findsinglechoice();
        this.edit = false;
      }
    },
    //选项
    addnumber() {
      for (let i = 0; i < this.indexs; i++) {
        this.chooseList.push(this.chooseList1[i]);
        console.log(this.form.chooseList);
      }
    },
    //增加选项
    addChooseList() {
      if (this.indexs >= this.chooseList1.length) {
        this.indexs = this.chooseList1.length;
        return this.$message.warning('选项数量达到上限！');
      } else {
        this.chooseList1[this.indexs].radio1 = '';
        this.chooseList1[this.indexs].audio1 = '';
        this.chooseList1[this.indexs].img = '';
        this.chooseList1[this.indexs].id = '';
        this.chooseList1[this.indexs].content = '';
        this.chooseList1[this.indexs].right = 1;
        this.chooseList.push(this.chooseList1[this.indexs]);
        this.indexs++;
      }
    },
    //删减选项
    removeChooseList() {
      this.indexs--;
      this.optionsId = this.chooseList[this.chooseList.length-1].id;
      this.chooseList.splice(this.indexs);
      if(this.edit == false) {
        this.editRemoveChoose();
      }
      console.log(this.chooseList,this.chooseList.length);
    },
    //删除选项音频
    removeitemaudio(item) {
      item.audio = '';
    },
    //删除选项图片
    removeitemimg(item) {
      item.img = '';
    },
    //删除音频
    removeaudio() {
      this.audiosrc = '';
      this.$message.success('删除成功!');
    },
    //删除图片
    removeimage() {
      this.imageUrl = '';
      this.$message.success('删除成功!');
    },
    //编辑时删除选项的接口
    editRemoveChoose(){
      console.log(this.optionsId,"两个数",this.$route.query.id,);
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exercise/option/'+this.$route.query.id+'/'+this.optionsId+'/del',
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, 'awawa');
        })
        .catch((err) => {
          this.$message.error( err);
        });
    },
    //上传音频
    handleAvatarSuccess(data) {
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('audio', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadAudio',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, 'awawa');
          this.audiosrc = result.data.data;
          this.$message.success('上传成功！');
        })
        .catch((err) => {
          this.$message.error('上传音频错误：' + err);
        });
    },
    beforeAvatarUpload(file) {
      const flieArr = file.name.split('.');
      const isMP3 = flieArr[flieArr.length - 1] === 'mp3';
      const isLt2M = file.size / 1024 / 1024 < 100;

      if (!isMP3) {
        this.$message.error('上传音频只能是 MP3 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传音频大小不能超过 100MB!');
        return false;
      }
      return isMP3 && isLt2M;
    },
    //上传图片
    handleAvatarSuccessImg(data) {
      console.log(data.file);
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.imageUrl = result.data.data;
            this.$message.success('上传成功！');
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },
    beforeAvatarUploadImg(file) {
      // const isJPG = file.type === 'image/jpeg';
      // const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isPNG) {
      //   this.$message.error('上传图片只能是 JPG或者PNG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return  isLt2M;
    },
    //上传选项音频
    handleAvatarSuccess1(data) {
      //  this.selector1();
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('audio', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadAudio',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          this.chooseList[this.chooseaudioid - 1].audio = result.data.data;
          console.log(this.chooseList[this.chooseaudioid - 1].audio, 'aaaa');
          console.log(this.chooseList, 'aaaaq2qw');
          this.$message.success('上传成功！');
        })
        .catch((err) => {
          this.$message.error('上传音频错误：' + err);
        });
    },
    //上传选项图片
    handleAvatarSuccessImg1(data) {
      console.log(data.file);
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.chooseList[this.chooseaudioid - 1].img = result.data.data;
            console.log(this.chooseList[this.chooseaudioid - 1].img, 'aaaa');
            console.log(this.chooseList);
            this.$message.success('上传成功！');
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },
    beforeAvatarUpload(file) {
      const flieArr = file.name.split('.');
      const isMP3 = flieArr[flieArr.length - 1] === 'mp3';
      const isLt2M = file.size / 1024 / 1024 < 100;

      if (!isMP3) {
        this.$message.error('上传音频只能是 MP3 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传音频大小不能超过 100MB!');
        return false;
      }
      return isMP3 && isLt2M;
    },
    //返回大题列表
    comeBackBig(big) {
      this.updatechoice(big);
    },
    comeBacksmall(big) {
      this.updatechoice(big);
    },
    selector() {
      for (let i = 0; i < this.chooseList.length; i++) {
        this.chooseList[i].right = 1;
        console.log(this.chooseList.length);
      }
      console.log(this.form.chooseListAnswer);
      for (let i = 0; i < this.chooseList.length; i++) {
        if (this.form.chooseListAnswer.indexOf(this.chooseList[i].label) == -1) {
          this.chooseList[i].right = 0;
        }
      }
      console.log(this.chooseList);
    },
    selector1(item) {
      console.log(item, 'aaa');
      if (item.label === 'A') {
        this.chooseaudioid = 1;
        console.log(this.chooseaudioid, 'aaa');
      }
      if (item.label === 'B') {
        this.chooseaudioid = 2;
        console.log(this.chooseaudioid, 'aaa');
      }
      if (item.label === 'D') {
        this.chooseaudioid = 3;
        console.log(this.chooseaudioid, 'aaa');
      }
      if (item.label === 'D') {
        this.chooseaudioid = 4;
        console.log(this.chooseaudioid, 'aaa');
      }
      if (item.label === 'E') {
        this.chooseaudioid = 5;
        console.log(this.chooseaudioid, 'aaa');
      }
    },
    //查询选择题
    findsinglechoice() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exercise/' + this.$route.query.questionId + '/multiple-choice',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          let data = res.data.data;
          this.form.title = data.text;
          this.audiosrc = data.audio;
          this.imageUrl = data.img;
          this.form.radios = data.level;
          this.form.answerparse = data.parse;
          this.form.points = data.points;
          this.chooseList = data.options;
          this.indexs = data.options.length;
          for (let i = 0; i < data.options.length; i++) {
            if (data.options[i].right === 1) {
              this.form.chooseListAnswer.push(data.options[i].label);
            }
          }
        }
        console.log(this.chooseList);
      });
    },
    //编辑习题
    editupdate() {
      console.log(this.chooseList,"这是选项");
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/' + this.$route.query.id + '/' + this.$route.query.questionId + '/multiple-choice/upd',
        method: 'POST',
        data: {
          audio: this.audiosrc,
          img: this.imageUrl,
          level: this.form.radios,
          options: this.chooseList,
          parse: this.form.answerparse,
          points: this.form.points,
          score: 0,
          text: this.form.title,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          this.$message.success('编辑成功！');
          this.$router.go(-1);
        }
        else {
          this.$message.warning(res.data.message);
        }
      });
    },
    //提交选择题
    updatechoice(big) {
      this.selector();
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/make/multiple-choice',
        method: 'POST',
        data: {
          attached: {
            bookId: Number(this.$route.query.bookid),
            section: this.$route.query.littleNode,
          },
          audio: this.audiosrc,
          img: this.imageUrl,
          level: this.form.radios,
          options: this.chooseList,
          pack: {
            number: this.$route.query.number,
            questionPackId: this.$route.query.id,
            score: 0,
          },
          parse: this.form.answerparse,
          points: this.form.points,
          score: 0,
          text: this.form.title,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          console.log(res);
          if (res.data.code === 0) {
            if (big === 1) {
              this.$router.go(-2);
            } else if (big === 2) {
              this.$router.go(-1);
            }
            this.form.chooseListAnswer = [];
            this.$message.success('提交成功！');
            this.chooseList=[];
            this.indexs = 4;
            this.addnumber();
            this.chooseList1.forEach((item)=>{
                item.content='';
                item.radio1 = '';
                item.img='';
                item.id = '';
                item.right=1;
            });
            this.form.title = '';
            this.imageUrl = '';
            this.form.radios = '';
            this.form.answerparse = '';
            this.form.points = '';
            this.audiosrc = '';
            for (let i = 0; i < this.chooseList.length; i++) {
              this.chooseList[i].right = 1;
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
         if(big ==1||big==2){
             this.$confirm('必填信息出错，退出信息将被清空，确定退出?', '退出', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            console.log(111);
            if (big === 1) {
              this.$router.go(-2);
            } else if (big === 2) {
              this.$router.go(-1);
            }
          });
          }else {
            this.$message.error('制题失败:'+err)
          }
        });
    },
  },
};
</script>
<style lang="less">
.mains {
  box-sizing: border-box;
}
.el-card_body {
  position: relative;
}
.tishi {
  position: absolute;
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 3.4375rem /* 55/16 */;
}
.form_1 {
  margin-top: 70px;
  margin-left: 273px;
}
.xiaoqu_1 {
  font-weight: 700;
}
.xtfl {
  width: 750px /* 750/16 */;
}
.expansion {
  position: absolute;
  top: 0;
  right: 360px;
}
.xtfl1 {
  position: relative;
  width: 750px /* 750/16 */;
  height: 12.5rem /* 200/16 */;
  border: 1px solid #cccccc;
}
.xtfl1 h3 {
  margin-left: 1.875rem /* 30/16 */;
  margin-top: 10px;
}

.xtfl1 button {
  position: absolute;
  top: 0;
  right: -100px;
}
.example {
  margin-left: 1.875rem /* 30/16 */;
  margin-top: -20px;
}
.example span {
  display: inline-block;
  margin-right: 10px;
}
.example_img {
  margin-left: 1.875rem /* 30/16 */;
  width: 6.25rem /* 100/16 */;
  height: 6.25rem /* 100/16 */;
}
.options {
  display: flex;
  width: 750px /* 750/16 */;
  height: 12.5rem /* 200/16 */;
  border: 1px solid #cccccc;
  margin-bottom: 20px;
}
.options_left {
  width: 130px;
  height: 100%;
  background-color: #cccccc;
  color: white;
  text-align: center;
}
.options_left p {
  font-size: 16px;
  margin-top: 70px;
}
.options_left_radio {
  color: #fff;
}
.options_right {
  position: relative;
  .right_button {
    position: absolute;
    display: flex;
    right: -260px;
    top: 0;
  }
}
.addLable {
  width: 12.5rem /* 200/16 */;
  height: 2.25rem /* 36/16 */;
}
.btn_addlable {
  width: 6rem /* 96/16 */;
  height: 2.125rem /* 34/16 */;
  margin-left: 1.5625rem /* 25/16 */;
}
.el-textarea__inner {
  resize: none;
}
.score {
  display: flex;
}
.score > :nth-child(2) {
  margin: 0 110px 0 140px;
}
.grade {
  width: 6.25rem /* 100/16 */;
}
.tishi {
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 3.4375rem /* 55/16 */;
}
.look_picture {
  width: 750px;
  height: 200px;
  border: 1px solid #cccccc;
}
.replaceaudio {
  position: relative;
  width: 100px /* 65/16 */;
  height: 42px;
  button {
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .picture {
    position: absolute;
    width: 100px;
    height: 42px;
    margin-left: 200px;
    bottom: 40px;
  }
}
.addaudio {
  display: flex;
  width: 730px;
  height: 55px;
  border: 1px solid rgba(204, 204, 204, 1);
  padding: 10px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
}
</style>
